const _loops = []
let iterationIndex = 0

/**
 * Retrieves the execution-stack.
 */
export function getLoops() {
  return _loops
}

/**
 * Update the current execution stack with the provided delta
 * @param {*} delta - The delta to push to each function in the execution-stack
 */
export function updateLoops(delta) {
  iterationIndex = _loops.length
  while (--iterationIndex >= 0) {
    _loops[iterationIndex](delta)
  }
}

/**
 * Cancels a loop and removes it from the execution stack.
 * @param {function} loop - The function whose loop should be canceled.
 */
export function stopLoop(loop) {
  const index = _loops.indexOf(loop)
  if (index >= 0) {
    _loops.splice(index, 1)
    if (index <= iterationIndex) {
      iterationIndex -= 1
    }
  }
}

/**
 * Adds a function to the execution stack
 * @param {*} loop - The function to start looping
 */
export function startLoop(loop) {
  const index = _loops.indexOf(loop)
  if (index === -1) {
    _loops.push(loop)
  }
}

